<template>
  <div>
    <v-dialog
      scrollable
      v-model="show_dialog"
      width="1050"
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title
          class="text-h5 white--text primary_2 d-flex justify-space-between align-center"
        >
          <div>{{ title }} Offers</div>

          <div>
            <v-btn @click="show_dialog = false" icon
              ><v-icon color="white">mdi-close</v-icon></v-btn
            >
          </div>
        </v-card-title>
        <v-card-text class="py-5 text-center text-h6">
          <v-data-table
            :headers="headers"
            :items="offer_list"
            :items-per-page="50"
            class="border-a border-0 custome-header-bg"
            hide-default-footer
            loading-text="Loading...."
          >
            <template v-slot:[`item.bank_logo`]="{ item }">
              <img :src="item.bank_logo" :alt="item.title" class="bank-logo" />
            </template>
            <template v-slot:[`item.offer_status`]="{ item }">
              <div v-if="item.offer_status">
                {{ item.offer_status }}
              </div>
              <div v-else>-</div>
            </template>
            <template v-slot:[`item.flag_offer_availed`]="{ item }">
              <div>
                <v-icon v-if="item.flag_offer_availed">mdi-check-circle-outline</v-icon>
                <v-icon color="error" v-else>mdi-close-circle-outline</v-icon>
              </div>
            </template>
            <template v-slot:[`item.loan_sub_status`]="{ item }">
              <div v-if="item.loan_sub_status">
                {{ item.loan_sub_status }}
              </div>
              <div v-else>-</div>
            </template>
            <template v-slot:[`item.loan_status`]="{ item }">
              <div v-if="item.loan_status">
                {{ item.loan_status | stageLabel }}
              </div>
              <div v-else>-</div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="copyOfferLink(item.redirect_url)"
                    >
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </template>
                  <span>Copy UTM Link</span>
                </v-tooltip>
                
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      text
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="editLoanStatus(item)"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Edit Loan Status</span>
                </v-tooltip>
              </div>
          </template>
            <template v-slot:[`item.benefits`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" dark v-bind="attrs" v-on="on">
                    mdi-eye-outline
                  </v-icon>
                </template>
                <ul>
                  <!-- {{item.benefits}} -->
                  <li
                    v-for="(benefit, index) in item.credit_card_benefits"
                    :key="index"
                  >
                    {{ benefit }}
                  </li>
                </ul>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <EditLoanStatus @reload="updateOfferSatus" ref="editLoanStatusDialog"/>
  </div>
</template>
<script>
import EditLoanStatus from "./editLoanStatus.vue";
export default {
  components: { EditLoanStatus },
  data() {
    return {
      show_dialog: false,
      title: "",
      offer_list: [],
      headers: [],
      pl_offer_header: [
        {
          text: "Id",
          value: "id",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Bank Logo",
          value: "bank_logo",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Title",
          value: "title",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Interest Rate",
          value: "interest_rate",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Loan Upto",
          value: "loan_upto",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Tenure",
          value: "tenure",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Is Offer Availed",
          value: "flag_offer_availed",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Loan Status",
          value: "loan_status",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Loan Sub Status",
          value: "loan_sub_status",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "center",
          class: "blue-grey lighten-4 font-weight-bold",
        },
        // {
        //   text: "Offer Status",
        //   value: "offer_status",
        //   sortable: false,
        //   class: "blue-grey lighten-4 font-weight-bold",
        // },
      ],
      cc_offer_header: [
        {
          text: "Id",
          value: "id",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Bank Logo",
          value: "bank_logo",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Title",
          value: "title",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Joining Fees",
          value: "joining_fees",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Annual Charges",
          value: "annual_charges",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Is Offer Availed",
          value: "flag_offer_availed",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Loan Status",
          value: "loan_status",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Loan Sub Status",
          value: "loan_sub_status",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        // {
        //   text: "Offer Status",
        //   value: "offer_status",
        //   sortable: false,
        //   class: "blue-grey lighten-4 font-weight-bold",
        // },
        {
          text: "Benefits",
          value: "benefits",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          class: "blue-grey lighten-4 font-weight-bold",
        },
      ],
    };
  },
  methods: {
    async copyOfferLink(url) {
      if (!url) {
        this.$store.dispatch("snackbar/setSnackbar", {
          flag: true,
          text: "UTM Link Not Found",
          color: "error",
        });
        return;
      }
      const copied = await this.copyTextToClipboard(url);
      this.$store.dispatch("snackbar/setSnackbar", {
        flag: true,
        text: copied ? "UTM Link Copied Successfully" : "Failed to copy UTM Link",
        color: copied ? "success" : "error",
      });
    },
    async copyTextToClipboard(text) {
      // navigator.clipboard only exists in a secure context (HTTPS/localhost).
      // The panel is served over plain HTTP, so fall back to execCommand there.
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
          return true;
        }
      } catch (err) {
        // fall through to the legacy path below
      }
      // Legacy fallback. Use a Range + window Selection (NOT a focused input):
      // this component lives inside a Vuetify v-dialog whose focus trap would
      // steal focus from a textarea before execCommand runs, copying nothing.
      // execCommand("copy") copies the current window selection regardless of
      // which element is focused, so the dialog cannot interfere.
      let span = null;
      const selection = window.getSelection();
      const previousRange =
        selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : null;
      try {
        span = document.createElement("span");
        span.textContent = text;
        span.style.position = "fixed";
        span.style.left = "-9999px";
        span.style.whiteSpace = "pre";
        document.body.appendChild(span);

        const range = document.createRange();
        range.selectNodeContents(span);
        selection.removeAllRanges();
        selection.addRange(range);

        const ok = document.execCommand("copy");
        return ok;
      } catch (err) {
        return false;
      } finally {
        if (span) document.body.removeChild(span);
        // restore whatever the user had selected before
        if (selection) {
          selection.removeAllRanges();
          if (previousRange) selection.addRange(previousRange);
        }
      }
    },
    editLoanStatus(item) {
      this.$refs.editLoanStatusDialog.openDialog({
        loan_id: item.id,
        remark: item.remark,
        disbursement_date: item.disbursal_date,
        disbursed_amount: item.disbursal_amount,
        loan_status: item.loan_status,
        loan_sub_status: item.loan_sub_status,
        show_dialog: true,
      });
    },
    updateOfferSatus () {
      this.show_dialog = false;
      this.$emit("update");
    },
    async openOffersListDialog(title, list) {
      this.show_dialog = true;
      this.title = title;
      if (title == "Credit Card") {
        this.headers = this.cc_offer_header;
      } else if (title == "Personal Loan" || title == "Business Loan") {
        this.headers = this.pl_offer_header;
      }
      this.offer_list = list;
    },
  },
};
</script>
<style scoped>
.bank-logo {
  width: 100px;
  height: 80px;
}
</style>
